<template lang="pug">
    .services-item(v-if="content")
        .page__wr.services-item__wr
            ul.services-item__nav
                li.services-item__nav-item(v-for="(item, index) in content.nav" :key="index" :class="{'services-item__nav-item--active': index == content.nav.length-1}")
                    router-link(:to="item.link") {{ item.name }}
            .services-item__main
                .services-item__main-left(:class="{'services-item__main-left--extended': content.extendedService}")
                    h2.services-item__headline {{ content.title }}
                    form.services-item__main-left-form(v-on:submit.prevent="sendForm" :class="{'services-item__form-send--show': !formSend, 'services-item__main-left-form--hide': formSend}")
                        .services-item__main-left-form-steps(v-if="content.extendedService")
                            .services-item__main-left-form-step.services-item__main-left-form-step-one.services-item__main-left-form-step--active
                                .services-item__main-left-form-step-number 1
                            .services-item__main-left-form-steps-line
                            .services-item__main-left-form-steps-active
                            .services-item__main-left-form-step.services-item__main-left-form-step-two
                                .services-item__main-left-form-step-number 2
                        label.services-item__main-left-form-label.services-item__main-left-form-label--placeholder(v-if="content.extendedService") Опишите нужную Вам услугу
                        label.services-item__main-left-form-label Что нужно сделать?
                        input.services-item__main-left-form-input.services-item__main-left-form-input--top(type="text" required :placeholder="content.formPlaceholder" v-model="serviceName" v-on:input="prevStepActive")
                        label.services-item__main-left-form-label(v-if="content.extendedService") Подробное описание
                        textarea.services-item__main-left-form-textarea(v-if="content.extendedService" required :placeholder="content.formDescription" v-model="description" v-on:input="prevStepActive")
                        label.services-item__main-left-form-label(v-if="content.extendedService") Условия оплаты
                        .services-item__main-left-form-block(v-if="content.extendedService")
                            .services-item__main-left-form-item(v-for="payment in content.payment" :key="payment.unicId")
                                input.services-item__main-left-form-radio.services-item__main-left-form-radio--payment(type="radio" name="payment" :id="payment.unicId" :value="payment.name"  v-model="termsOfPayment")
                                label.services-item__main-left-form-radio-label(:for="payment.unicId") {{ payment.name }}
                        label.services-item__main-left-form-label(v-if="content.extendedService") Готов ждать предложения
                        .services-item__main-left-form-block(v-if="content.extendedService")
                            .services-item__main-left-form-item(v-for="(period, index) in content.waitingPeriod" :key="period.unicId" :class="{'services-item__main-left-form-item--date': index == content.waitingPeriod.length - 2}")
                                input.services-item__main-left-form-radio.services-item__main-left-form-radio--waiting(type="radio" name="period" :id="period.unicId" :value="period.name" v-model="waitingPeriod" v-on:change="inputUnlock($event)")
                                label.services-item__main-left-form-radio-label(:for="period.unicId") {{ period.name }}
                            .services-item__main-left-form-datepicker.services-item__main-left-form-datepicker--disabled
                                Datepicker(:language="ru" :format="format" :full-month-name="true" :monday-first="true" :placeholder="placeholder" :name="name" @selected="dateInput()" v-model="datepicker")
                                .services-item__main-left-form-decor
                                    SvgIcon(name="calendar" width="32" height="32")
                        label.services-item__main-left-form-label(:class="{'services-item__main-left-form-label--top': content.extendedService}") Указать контакты
                        .services-item__main-left-form-block
                            input.services-item__main-left-form-input(type="text" required placeholder="Ваше имя" v-model="personName" v-on:click="nextStepActive")
                            input.services-item__main-left-form-input(type="tel" name="phone" v-model="phone" v-mask="'+7(###)-###-##-##'" placeholder="+7(____)-____-___-___")
                            input.services-item__main-left-form-input(type="email" required placeholder="E-mail" v-if="!content.extendedService" v-model="email")
                        .services-item__main-left-form-block
                            button.services-item__main-left-form-button(type="submit") Отправить заявку
                            div.services-item__main-left-form-description
                                p.services-item__main-left-form-description-text Нажимая кнопку «Опубликовать», я даю согласие
                                p.services-item__main-left-form-description-text нa
                                    router-link(to="/politika-konfidencial-nosti" target="_blank").services-item__main-left-form-description-text--link  обработку персональных данных
                    .services-item__form-send(:class="{'services-item__form-send--show': formSend}")
                        h5.services-item__form-send-text Ваша заявка успешно отправлена!
                        h5.services-item__form-send-text Скоро мы свяжемся с Вами
                    h2.services-item__headline.services-item__headline--products(v-if="content.extendedService && windowWidth < 1200") Товары к этой услуге
                    .services-item__main-right-products(v-if="content.extendedService && windowWidth < 1200")
                        .swiper-container
                            .swiper-wrapper
                                .swiper-slide.services-item__main-right-products-slide(v-for="(item, index) in content.productSlider" :key="index")
                                    router-link.services-item__main-right-products-item(:to="item.link")
                                        .services-item__main-right-products-item-img-wr
                                            img.services-item__main-right-products-item-img(:src='item.image.path' :alt="item.image.name" v-show='!imgHide')
                                            .services-item__main-right-products-item-background(v-show='imgHide')
                                        .services-item__main-right-products-item-description
                                            h5.services-item__main-right-products-item-description-text {{ item.name }}
                        .services-item__main-right-products-navigation
                            .swiper-button-prev
                                SvgIcon.swiper-button-prev-icon(class='services-item__main-right-products-ico' name="arrow" width="18" height="29")
                            .swiper-button-next
                                SvgIcon.swiper-button-prev-icon(class='services-item__main-right-products-ico' name="arrow" width="18" height="29")
                .services-item__main-right
                    h2.services-item__headline {{ content.serviceName }}
                    .services-item__main-right-container
                        .services-item__main-right-text-wr
                            .services-item__main-right-text(v-html="content.serviceDescription")
                        .services-item__main-right-slider
                            .swiper-container
                                .swiper-wrapper
                                    .swiper-slide.services-item__main-right-swiper-slide(v-for="(image, index) in content.slider" :key="index")
                                        .services-item__main-right-slider-item
                                            .services-item__main-right-slider-item-layout
                                            .services-item__main-right-slider-item-img-wr
                                                img.services-item__main-right-slider-item-img(:src='image.path' :alt="image.name" v-show='!imgHide')
                                                .services-item__main-right-slider-item-background(v-show='imgHide')
                            .services-item__main-right-slider-navigation
                                .swiper-button-prev
                                    SvgIcon(class='services-item__main-right-slider-ico' name="arrow-left" width="11" height="19")
                                .services-item__main-right-slider-pagination.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets
                                .swiper-button-next
                                    SvgIcon(class='.services-item__main-right-slider-ico' name="arrow-right" width="11" height="19")
                        h2.services-item__headline(v-if="content.extendedService && windowWidth > 1200") Товары к этой услуге
                        .services-item__main-right-products(v-if="content.extendedService && windowWidth > 1200")
                            .swiper-container
                                .swiper-wrapper
                                    .swiper-slide.services-item__main-right-products-slide(v-for="(item, index) in content.productSlider" :key="index")
                                        router-link.services-item__main-right-products-item(:to="item.link")
                                            .services-item__main-right-products-item-img-wr
                                                img.services-item__main-right-products-item-img(:src='item.image.path' :alt="item.image.name" v-show='!imgHide')
                                                .services-item__main-right-products-item-background(v-show='imgHide')
                                            .services-item__main-right-products-item-description
                                                h5.services-item__main-right-products-item-description-text {{ item.name }}
                            .services-item__main-right-products-navigation
                                .swiper-button-prev
                                    SvgIcon.swiper-button-prev-icon(class='services-item__main-right-products-ico' name="arrow" width="18" height="29")
                                .swiper-button-next
                                    SvgIcon.swiper-button-prev-icon(class='services-item__main-right-products-ico' name="arrow" width="18" height="29")
</template>

<script>
    import EventBus from '@/eventBus';

    import '@/components/common/serviceItem/serviceItem.styl';
    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import {SliderHelpersVue} from "@/mixins/SliderHelpersVue";
    import {FormHelpersVue} from '@/mixins/FormHelpersVue';
    import {ScrollbarHelpers} from "@/mixins/ScrollbarHelpers";
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
    import Datepicker from 'vuejs-datepicker';
    import {ru} from 'vuejs-datepicker/dist/locale'

    export default {
        name: 'ServicesItem',
        mixins: [AjaxHelpersVue, SliderHelpersVue, FormHelpersVue, ScrollbarHelpers],

        data() {
            return {
                content: null,
                imgHide: true,
                objImages: [],
                serviceName: '',
                description: '',
                phone: '',
                email: '',
                comment: '',
                waitingPeriod: [],
                date: '',
                termsOfPayment: [],
                personName: '',
                formSend: false,
                ru: ru,
                format: 'dd.MM.yyyy',
                placeholder: '__.__.____',
                name: 'date',
                datepicker: null,
                windowWidth: 0,
                formName: ''
            }
        },

        components: {
            SvgIcon,
            Datepicker
        },

        created() {
            // Загрузка данных для страницы
            this.$nextTick(() => {
                this.request(this.$router.currentRoute.params.type);
                this.windowWidth = $(window).width();
            });

            EventBus.$on('imgLoaded', res => {
                this.imgHide = res;
            });
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                // экземпляр компонента доступен как `vm`
                EventBus.$emit('pagePreloaderShow');
                vm.scrollbarCheck();
                setTimeout(() => {
                    EventBus.$emit('setMenuTopActiveClass', to.path);
                    vm.request(to.params.type);
                }, 50);
            })
        },

        beforeRouteUpdate(to, from, next) {
            EventBus.$emit('pagePreloaderShow');
            this.scrollbarCheck();
            setTimeout(() => {
                EventBus.$emit('setMenuTopActiveClass', to.path);
                this.request(to.params.type);
                next();
            }, 50);
        },

        methods: {
            request(url) {
              this.formName = url;

                this.req('ServicesPage:getServiceItem', {name: url}, res => {
                    this.checkOverflow(this.$router.currentRoute.path);
                    this.content = res.content;
                    if(this.content.status === 'ok') {
                        for (let i = 0; i < this.content.slider.length; i++) {
                            this.objImages = this.objImages.concat({loaded: false, url: this.content.slider[i].path});
                        }
                        for (let i = 0; i < this.content.productSlider.length; i++) {
                            this.objImages = this.objImages.concat({
                                loaded: false,
                                url: this.content.productSlider[i].image.path
                            });
                        }
                        this.checkImgLoading(this.objImages);
                        EventBus.$emit('pagePreloaderHide');
                        this.$nextTick(() => {
                            this.initSlider('.services-item__main-right-slider', 'services-item__main-right-slide');
                            if(this.windowWidth > 760) {
                                this.customScrollbarInit('.services-item__main-right-text-wr');
                            }
                            let params = {
                                init: false,
                                centeredSlides: false,
                                speed: 600,
                                spaceBetween: 0,
                                slidesPerView: 2,
                                slideDuplicateClass: 'swiper-slide-duplicate',
                                navigation: {
                                    nextEl: $('.services-item__main-right-products').find('.swiper-button-next'),
                                    prevEl: $('.services-item__main-right-products').find('.swiper-button-prev')
                                },
                                breakpoints: {
                                    // when window width is >= 640px
                                    760: {
                                        slidesPerView: 1,
                                    },
                                },
                                simulateTouch: true,
                                observer: true,
                                observeParents: true,
                            };
                            this.initSlider('.services-item__main-right-products', 'services-item__main-right-product', '', '', params);
                            if(res.content.extendedService) {
                                let el1 = $('.services-item__main-left-form-radio--payment')[0];
                                let el2 = $('.services-item__main-left-form-radio--waiting')[0];
                                $(el1).prop("checked", "true");
                                $(el2).prop("checked", "true");
                                this.termsOfPayment[0] = $(el1).val();
                                this.waitingPeriod[0] = $(el2).val();
                            }
                        })
                    } else {
                        this.$router.push('/*');
                    }
                });
            },
            sendForm() {
                let yaType = '';

                let data = {
                    serviceName: this.serviceName,
                    email: this.email,
                    phone: this.phone,
                    personName: this.personName,
                    description: this.description,
                    waitingPeriod: this.waitingPeriod,
                    waitingPeriodDate: this.date,
                    termsOfPayment: this.termsOfPayment,
                };

                this.submitForm('ServicesPage:sendForm', data, res => {
                    this.personName  = '';
                    this.email = '';
                    this.phone = '';
                    this.description = '';
                    this.serviceName = '';
                    this.waitingPeriod = '';
                    this.termsOfPayment = '';
                    this.date = '';
                    if(res.status === 'ok') {
                        this.formSend = true;
                    }
                });

              if(this.formName === 'inzhiniring') {
                yaType = 'engineering';
              }
              if(this.formName === 'proizvodstvo') {
                yaType = 'production';
              }
              if(this.formName === 'servis') {
                yaType = 'service';
              }
              if(this.formName === 'stroyka') {
                yaType = 'building';
              }

              ym(61363291, 'reachGoal', yaType);
            },

            inputUnlock(event) {
                let elem = event.target;
                let $input = $('.services-item__main-left-form-datepicker');
                if(this.waitingPeriod === this.content.waitingPeriod[2].name) {
                    $input.removeClass('services-item__main-left-form-datepicker--disabled');
                    $('.services-item__main-left-form-step-two').removeClass('services-item__main-left-form-step--active');
                    setTimeout(() => {
                        $('.services-item__main-left-form-steps-active').css('transform', 'translateY(-100%)');
                    }, 200);
                } else {
                    $input.addClass('services-item__main-left-form-datepicker--disabled');
                    $('input[name="date"]').val('');
                    this.date = '';
                    this.datepicker = null;
                }
            },

            nextStepActive() {
                if(this.content.extendedService) {
                    if (this.serviceName !== '' && !this.description == '') {
                        if(this.waitingPeriod === this.content.waitingPeriod[2].name && this.date !== '' || this.waitingPeriod !== this.content.waitingPeriod[2].name) {
                            $('.services-item__main-left-form-steps-active').css('transform', 'translateY(0)');
                            setTimeout(() => {
                                $('.services-item__main-left-form-step-two').addClass('services-item__main-left-form-step--active');
                            }, 300);
                        }
                    }
                }
            },

            prevStepActive() {
                if(this.content.extendedService) {
                    if (this.serviceName == '' || this.description == '') {
                        $('.services-item__main-left-form-step-two').removeClass('services-item__main-left-form-step--active');
                        setTimeout(() => {
                            $('.services-item__main-left-form-steps-active').css('transform', 'translateY(-100%)');
                        }, 200);
                    }
                }
            },

            dateInput() {
                this.$nextTick(() => {
                    this.date = $('input[name="date"]').val();
                });
            }
        }
    }
</script>
